import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

export type SharedBy = {
  sharedBy: {
    userId: string
    username: string
    avatarUrl: string
  }
}

const sharePost = (
  postId: number | string,
  ownerId: number | string
): Response<Post & SharedBy> => {
  return axios.post(`/v6/posts/${postId}/shared/${ownerId}`)
}

export default sharePost
